import React, { useState } from 'react';
import '../ToggleSwitch.css';

const Toggle = ({ label, isOn, setIsOn, children }) => {
    const handleToggle = () => {
        setIsOn(!isOn);
    };

    return (
        <div className={`toggle-container ${isOn ? 'active' : ''}`}>
            <div className="label" onClick={handleToggle}>
                <span className="inner">
                    <span className="label-text">{label}</span>
                    <span className="status-text">{isOn ? 'ON' : 'OFF'}</span>
                </span>
                <span className="switch" />
            </div>
            {isOn && <div className="associated-component">{children}</div>}
        </div>
    );
};

export default Toggle;